import {
    UPLOAD_BY_LINK_CANNOT_DOWNLOAD_LIVE,
    UPLOAD_BY_LINK_CANNOT_LIVE_NO_START,
    UPLOAD_BY_LINK_COUNTRY_NOT_AVAILABLE,
    UPLOAD_BY_LINK_DOWNLOAD_FAILED,
    UPLOAD_BY_LINK_INCOMPLETE_LINKS,
    UPLOAD_BY_LINK_IS_DRM_PROTECTED,
    UPLOAD_BY_LINK_LINK_NOT_LEGITIMATE,
    UPLOAD_BY_LINK_PREMIERES_NOT_START,
    UPLOAD_BY_LINK_PRIVATE_VIDEO,
    UPLOAD_BY_LINK_SHORT_CODE_ERROR,
    UPLOAD_BY_LINK_TOO_MUCH_REQUEST,
    UPLOAD_BY_LINK_UNABLE_DOWNLOAD,
    UPLOAD_BY_LINK_UNABLE_DOWNLOAD_CANNOT_RETRIED,
    UPLOAD_BY_LINK_UNABLE_DOWNLOAD_DATA,
    UPLOAD_BY_LINK_VIDEO_CONTAINS_DISCOVERY,
    UPLOAD_BY_LINK_VIDEO_CONTAINS_DISNEY,
    UPLOAD_BY_LINK_VIDEO_CONTAINS_UNIVERSAL,
    UPLOAD_BY_LINK_VIDEO_HAS_DELETED,
    UPLOAD_BY_LINK_VIDEO_NOT_AVAILABLE,
    UPLOAD_BY_LINK_VIDEO_NOT_AVAILABLE_AND_NOT_DOWNLOAD,
    UPLOAD_BY_LINK_VIDEO_PROCESSING,
} from "@/constants";

/**
 * 国际化链接上传的错误信息（主要用于youtube）
 * @param errCode 错误code值
 */

export const translateWrongCopyUploadByLink = function (errCode) {
    let linkUploadErrorText = "Something went wrong, please try again";
    if (errCode == UPLOAD_BY_LINK_PRIVATE_VIDEO) {
        linkUploadErrorText = "Cannot download private video";
    } else if (errCode == UPLOAD_BY_LINK_VIDEO_CONTAINS_DISNEY) {
        linkUploadErrorText = "This video is not available";
    } else if (errCode == UPLOAD_BY_LINK_COUNTRY_NOT_AVAILABLE) {
        linkUploadErrorText = "The uploader has not made this video available in your country";
    } else if (errCode == UPLOAD_BY_LINK_VIDEO_HAS_DELETED) {
        linkUploadErrorText = "This video has been removed";
    } else if (errCode == UPLOAD_BY_LINK_VIDEO_NOT_AVAILABLE) {
        linkUploadErrorText = "This video is not available";
    } else if (errCode == UPLOAD_BY_LINK_VIDEO_CONTAINS_DISCOVERY) {
        linkUploadErrorText =
            "This video contains content from Discovery Communications, who has blocked it in your country on copyright grounds";
    } else if (errCode == UPLOAD_BY_LINK_VIDEO_CONTAINS_UNIVERSAL) {
        linkUploadErrorText =
            "This video contains content from Universal Pictures, who has blocked it in your country on copyright grounds";
    } else if (errCode == UPLOAD_BY_LINK_LINK_NOT_LEGITIMATE) {
        linkUploadErrorText = "Not a valid URL";
    } else if (errCode == UPLOAD_BY_LINK_DOWNLOAD_FAILED) {
        linkUploadErrorText = "An error occurred, please retry";
    } else if (errCode == UPLOAD_BY_LINK_UNABLE_DOWNLOAD_CANNOT_RETRIED) {
        linkUploadErrorText = "Unable to download video data";
    } else if (errCode == UPLOAD_BY_LINK_INCOMPLETE_LINKS) {
        linkUploadErrorText = "Incomplete YouTube ID, the URL looks truncated";
    } else if (errCode == UPLOAD_BY_LINK_UNABLE_DOWNLOAD) {
        linkUploadErrorText = "Unable to download video data, please retry";
    } else if (errCode == UPLOAD_BY_LINK_UNABLE_DOWNLOAD_DATA) {
        linkUploadErrorText = "Unable to download video data, please retry";
    } else if (errCode == UPLOAD_BY_LINK_VIDEO_PROCESSING) {
        linkUploadErrorText = "Video is being processing. Check back later";
    } else if (errCode == UPLOAD_BY_LINK_CANNOT_DOWNLOAD_LIVE) {
        linkUploadErrorText = "Cannot download live or recently ended videos. Please retry later.";
    } else if (errCode == UPLOAD_BY_LINK_CANNOT_LIVE_NO_START) {
        linkUploadErrorText = "Live has not started yet, please try again after live ended";
    } else if (errCode == UPLOAD_BY_LINK_VIDEO_NOT_AVAILABLE_AND_NOT_DOWNLOAD) {
        linkUploadErrorText = "This video is not available";
    } else if (errCode == UPLOAD_BY_LINK_PREMIERES_NOT_START) {
        linkUploadErrorText = "Premieres has not started yet, please try again after started";
    } else if (errCode == UPLOAD_BY_LINK_SHORT_CODE_ERROR) {
        linkUploadErrorText = "Please check the YouTube ID in the URL";
    } else if (errCode == UPLOAD_BY_LINK_IS_DRM_PROTECTED) {
        linkUploadErrorText = "This video is not available";
    } else if (errCode == UPLOAD_BY_LINK_TOO_MUCH_REQUEST) {
        linkUploadErrorText = "You\u0027ve exceed the download limit. Please try again later.";
    }
    return linkUploadErrorText;
};
